import React from "react"
import styled from "styled-components"
import { Button, Paragraph, Theme } from "@pga/pga-component-library"

import { useMemberApplyPath } from "../../../hooks/useMemberApplyPath"
import { flags, useFeatureFlags } from "../../../lib/feature-flags"
import { redirectToMemberApplications } from "../../../lib/ptmApplicationsRedirect"

const Card = styled.section`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
  margin-bottom: 20px;
  padding: 1rem 1.25rem;
  background-color: white;
  border-left: 4px solid ${Theme.colors.primary};
`

export const MEMBER_APPLY_CTA_LABEL = "Apply for Membership"

const MemberApplyEntry = ({ skip = false }) => {
  const [applicationsMembershipEnabled] =
    useFeatureFlags([flags.FLAG_FEAT_APPLICATIONS_MEMBERSHIP]) ?? []
  const { canApplyViaReciprocity } = useMemberApplyPath({
    skip: skip || applicationsMembershipEnabled !== true,
  })

  if (!canApplyViaReciprocity) {
    return null
  }

  return (
    <Card aria-label="Apply for Membership">
      <Paragraph fw="normal" className="mb-0">
        You are eligible to apply for PGA Membership.
      </Paragraph>
      <Button color="primary" onClick={redirectToMemberApplications}>
        {MEMBER_APPLY_CTA_LABEL}
      </Button>
    </Card>
  )
}

export default MemberApplyEntry
